'use client'

import { useEffect, useState } from 'react'

import Animate from '@/components/Animate'
import { useRouter } from 'next/navigation'
import Button from '@/components/ui/Button'

const fullSubtitle =
  'Forget IDEs. Build, ship, and improve software at the speed of AI.'

export default function Home() {
  const router = useRouter()
  const [subtitleText, setSubtitleText] = useState('')
  const [visible, setVisible] = useState(true)
  const [showButtons, setShowButtons] = useState(false)
  // Have them automatically generated?
  const questions = [
    {
      text: 'Run open-source AI models on your own hardware. 🤖',
      onClick: () => console.info('How question clicked')
    },
    {
      text: "Run AI in overnight loops to continuously improve your codebase. 🔄",
      onClick: () => console.info('Cost question clicked')
    },
    {
      text: 'Prisby is free and open-source. Your code and data stays yours ❤️',
      onClick: () => console.info('Start question clicked')
    }
    // {
    //   text: 'Who are the targets of this platform?',
    //   onClick: () => console.log('Start question clicked')
    // }
  ]

  useEffect(() => {
    const words = fullSubtitle.split(' ')
    const currentWordCount = subtitleText.split(' ').length

    if (currentWordCount < words.length) {
      const timeout = setTimeout(() => {
        setSubtitleText(words.slice(0, currentWordCount + 1).join(' '))
      }, 40)
      return () => clearTimeout(timeout)
    } else {
      setTimeout(() => setShowButtons(true), 500)
    }
  }, [subtitleText])

  return (
    <Animate
      visible={visible}
      onFadeOutComplete={() => {
        setTimeout(() => {
          router.push('/chat')
        }, 400)
      }}
      className={showButtons ? 'h-[40vh]' : ''}
    >
      <h1>
        <p className='text-lg sm:text-xl text-gray-600 min-h-[6rem]'>
          {subtitleText}
        </p>
      </h1>
      {showButtons && (
        <>
          <div className='grid gap-4 sm:grid-cols-1 md:grid-cols-3 mt-10'>
            {questions.map((question, index) => (
              <Animate key={index} delay={(index + 1) * 150}>
                <div
                  className='h-30 p-4 cursor-pointer hover:shadow-md transition-all duration-300 text-left border-1 border-gray-300 rounded-lg'
                  onClick={() => question.onClick()}
                >
                  <p className='font-medium'>{question.text}</p>
                </div>
              </Animate>
            ))}
          </div>
          <Animate delay={800}>
            {/* <Animate delay={150}> */}
            <div className='mt-6 flex justify-center'>
              <Button
                primary
                onClick={() => {
                  setVisible(false)
                }}
              >
                Get started for free ✨
              </Button>
            </div>
          </Animate>
        </>
      )}
    </Animate>
  )
}
